<template>
  <div>
    <div class="card card-custom card-sticky" v-if="!mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer">
            <span class="label label-xl label-dot label-primary mr-2"></span> Turno 1 - Mesa <i class="mr-2"></i>
            <small v-if="ui.estaCargandoDatos">Cargando datos de la ficha...</small>
            <small v-else-if="auth.mensajeNoAutorizadoEdicionTurno" class="text-danger">{{ auth.mensajeNoAutorizadoEdicionTurno }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm btn-light font-weight-bold" @click.prevent="doCargarFicha()"><i class="fa p-0 fa-sync" :class="[ui.estaCargandoDatos ? 'fa-spin ' : '']"></i></a>
        </div>
      </div>
    </div>
    <div class="card card-custom card-sticky" v-if="mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer" @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
            <span class="label label-xl label-dot label-primary mr-2"></span> Turno 1 - Mesa <i class="mr-2"></i>
            <small>{{ auth.fechaInicioTurno | time }} - {{ auth.fechaFinTurno | time }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <span v-if="auth.puedeCambiarEstadoFinalizado == true">
            <a href="#" v-if="finalizado == true" class="btn btn-sm btn-light-danger font-weight-bold mr-2" v-b-tooltip.left title="Presione para desbloquear" @click.prevent="doToggleFinalizado()"> <i class="fa fa-lock"></i>Finalizado</a>
            <a href="#" v-if="finalizado == false" class="btn btn-sm btn-light font-weight-bold mr-2" v-b-tooltip.left title="Presione para bloquear" @click.prevent="doToggleFinalizado()"> <i class="fa fa-unlock-alt"></i>Desbloquear</a>
          </span>
          <span v-if="auth.puedeCambiarEstadoFinalizado == false">
            <a href="#" v-if="finalizado == true" class="btn btn-sm btn-light-danger font-weight-bold mr-2"> <i class="fa fa-lock"></i>Finalizado</a>
          </span>

          <a href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" @click.prevent="doGuardado()"><i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i> Guardar cambios</a>

          <a href="#" class="btn btn-sm btn-light-warning font-weight-bold" @click.prevent="$emit('update:expandirContenido', !expandirContenido)"><i class="fa p-0" :class="[expandirContenido ? 'fa-chevron-up' : 'fa-chevron-down']"></i></a>
        </div>
      </div>
      <div class="card-body" v-show="expandirContenido">
        <form class="form" id="frm-mesa-turno-1">
          <div class="row">
            <div class="col-xl-2"></div>
            <div class="col-xl-8">
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">II. Instalación de mesas de votación</h3>

                <!-- 2.1. Número de mesa de votación -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.1. Número de mesa de votación:</label>
                  <div :class="ui.colRightClass">
                    <input v-model="actual.t1NumeroMesa" class="form-control" type="text" placeholder="Ingrese el número de mesa..." />
                  </div>
                </div>

                <!-- 2.2. ¿Cuántos votantes están registrados en esta mesa? -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.2. ¿Cuántos votantes están registrados en esta mesa?</label>
                  <div :class="ui.colRightClass">
                    <input v-model.number="actual.t1NroElectoresHabilesMesa" class="form-control" type="number" placeholder="Ingrese la cantidad de electores hábiles..." />
                  </div>
                </div>

                <!-- 2.3. Indique una alternativa obligatoria -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.3. La mesa de votación ¿inició con el sufragio en la hora establecida (7:00 a.m.) o no se instaló?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1MesaInstaloHoraEstablecida = true" class="btn" :class="[actual.t1MesaInstaloHoraEstablecida === true ? 'btn-success' : 'btn-outline-secondary']">Sí, inició</button>
                      <button type="button" @click.prevent="actual.t1MesaInstaloHoraEstablecida = false" class="btn" :class="[actual.t1MesaInstaloHoraEstablecida === false ? 'btn-danger' : 'btn-outline-secondary']">No se instaló</button>
                    </div>
                    <div v-if="actual.t1MesaInstaloHoraEstablecida === true" class="mt-2">
                      <label class="mb-1">Hora de inicio:</label>
                      <input type="time" class="form-control" v-model="actual.t1MesaInstaloHoraInicio" placeholder="HH:mm" />
                    </div>
                    <textarea v-if="actual.t1MesaInstaloHoraEstablecida === false" v-model="actual.t1MesaInstaloHoraEstablecidaDetalle" class="form-control mt-2" type="text" placeholder="Señale brevemente el motivo..." required></textarea>
                  </div>
                </div>

                <!-- 2.4. Faltaron miembros de mesa para realizar la instalación -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.4. Faltaron miembros de mesa para realizar la instalación</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1FaltaronMiembrosMesa = true" class="btn" :class="[actual.t1FaltaronMiembrosMesa === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1FaltaronMiembrosMesa = false" class="btn" :class="[actual.t1FaltaronMiembrosMesa === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t1FaltaronMiembrosMesa === true" v-model="actual.t1FaltaronMiembrosMesaDetalle" class="form-control mt-2" type="text" placeholder="Especifique los detalles..." required></textarea>
                  </div>
                </div>

                <!-- 2.5. ¿Alguno de los miembros de mesa presentes fue reclutado de la fila? -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.5. ¿Alguno de los miembros de mesa presentes fue reclutado de la fila?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1MiembroMesaReclutadoFila = true" class="btn" :class="[actual.t1MiembroMesaReclutadoFila === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1MiembroMesaReclutadoFila = false" class="btn" :class="[actual.t1MiembroMesaReclutadoFila === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t1MiembroMesaReclutadoFila === true" v-model="actual.t1MiembroMesaReclutadoFilaDetalle" class="form-control mt-2" type="text" placeholder="Especifique los detalles..." required></textarea>
                  </div>
                </div>

                <!-- 2.6. ¿El material electoral para la instalación de la mesa de votación está completo? -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.6. ¿El material electoral para la instalación de la mesa de votación está completo?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1MaterialElectoralCompleto = true" class="btn" :class="[actual.t1MaterialElectoralCompleto === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1MaterialElectoralCompleto = false" class="btn" :class="[actual.t1MaterialElectoralCompleto === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t1MaterialElectoralCompleto === false" v-model="actual.t1MaterialElectoralCompletoDetalle" class="form-control mt-2" type="text" placeholder="Especifique qué material falta..." required></textarea>
                  </div>
                </div>

                <!-- 2.7. ¿La ubicación de cabina de votación asegura el voto secreto? -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.7. ¿La ubicación de cabina de votación asegura el voto secreto?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1CabinaGarantizaVotoSecreto = true" class="btn" :class="[actual.t1CabinaGarantizaVotoSecreto === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1CabinaGarantizaVotoSecreto = false" class="btn" :class="[actual.t1CabinaGarantizaVotoSecreto === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t1CabinaGarantizaVotoSecreto === false" v-model="actual.t1CabinaGarantizaVotoSecretoDetalle" class="form-control mt-2" type="text" placeholder="Especifique el motivo..." required></textarea>
                  </div>
                </div>

                <!-- 2.8. ¿El ánfora de votación está debidamente sellada y se encuentra en buen estado de integridad? -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.8. ¿El ánfora de votación está debidamente sellada y se encuentra en buen estado de integridad?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1AnforaDebidamenteSellada = true" class="btn" :class="[actual.t1AnforaDebidamenteSellada === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1AnforaDebidamenteSellada = false" class="btn" :class="[actual.t1AnforaDebidamenteSellada === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t1AnforaDebidamenteSellada === false" v-model="actual.t1AnforaDebidamenteSelladaDetalle" class="form-control mt-2" type="text" placeholder="Especifique el motivo..." required></textarea>
                  </div>
                </div>

                <!-- 2.9. Se observa la presencia de PERSONEROS en esta etapa -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.9. Se observa la presencia de PERSONEROS en esta etapa</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1PresenciaPersonerosMesa = true" class="btn" :class="[actual.t1PresenciaPersonerosMesa === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1PresenciaPersonerosMesa = false" class="btn" :class="[actual.t1PresenciaPersonerosMesa === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t1PresenciaPersonerosMesa === true" class="mt-2">
                      <label class="mb-1">Cuántos y de qué partidos:</label>
                      <div class="card-body py-0">
                        <table class="table mb-0">
                          <tbody>
                            <tr v-for="(item, index) in actual.itemsPersonerosMesa" :key="'t1mesa-' + index">
                              <td><img class="symbol-label" :src="getImagenPartidoPolitico(item.organizacionPoliticaParamId)" style="width:40px;height:auto;" /></td>
                              <td class="w-75">
                                <select class="form-control" v-model="item.organizacionPoliticaParamId">
                                  <option :value="null">- Seleccione organización -</option>
                                  <optgroup label="Partidos Políticos">
                                    <option v-for="partido in partidosNacionales" :key="partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                  </optgroup>
                                  <optgroup label="Movimientos Regionales">
                                    <option v-for="partido in partidosRegionales" :key="'mr-' + partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                  </optgroup>
                                </select>
                                <input type="number" min="1" max="99" class="form-control mt-2 w-50" v-model="item.numero" placeholder="Cantidad..." />
                              </td>
                              <td><a href="#" class="btn btn-outline-secondary" @click.prevent="deleteItemPersonero(actual.itemsPersonerosMesa, item)"><i class="fa fa-trash p-0 text-danger"></i></a></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <a href="#" class="btn btn-secondary btn-sm" @click.prevent="addItemPersonero(actual.itemsPersonerosMesa)"><i class="fa fa-plus"></i> Agregar</a>
                      <textarea v-model="actual.t1PresenciaPersonerosMesaDetalle" class="form-control mt-2" type="text" placeholder="Detalle adicional (opcional)" rows="2"></textarea>
                    </div>
                  </div>
                </div>

                <!-- 2.10. Las listas de electores en cada mesa de votación, ¿se encuentran publicadas en zonas visibles y de fácil acceso? -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.10. Las listas de electores en cada mesa de votación, ¿se encuentran publicadas en zonas visibles y de fácil acceso?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t1ListaElectoresVisible = true" class="btn" :class="[actual.t1ListaElectoresVisible === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t1ListaElectoresVisible = false" class="btn" :class="[actual.t1ListaElectoresVisible === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t1ListaElectoresVisible === false" v-model="actual.t1ListaElectoresVisibleDetalle" class="form-control mt-2" type="text" placeholder="Especifique el motivo..." required></textarea>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-xl-2"></div>

            <div v-if="eventosActualizacion.length > 0" v-html="eventosActualizacion"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.table-hover tbody tr:hover {
  background-color: #f9f9f9;
}
</style>

<script>

import Swal from "sweetalert2";

export default {
  name: "ficha-mesa-turno-1",
  components: {},
  props: {
    mesaVotacionId: {
      type: Number,
    },
    localVotacionId: {
      type: Number,
    },
    procesoElectoralId: {
      type: Number,
    },
    expandirContenido: {
      type: Boolean,
    },
    intervaloAutoGuardado: {
      type: Number,
    },
  },
  data: () => ({
    finalizado: false,
    auth: {
      autorizadoEdicionTurno: null,
      mensajeNoAutorizadoEdicionTurno: null,
      puedeCambiarEstadoFinalizado: null,
      puedeEditarTurno: null,
      puedeVisualizarTurno: null,
      puedeFinalizarTurno: null,
      puedeReanudarTurno: null,
      fechaInicioTurno: null,
      fechaFinTurno: null,
      fechaInicioEdicionTurno: null,
      fechaFinEdicionTurno: null,
    },
    ui: {
      colLeftClass: "col-sm-12 col-md-5",
      colRightClass: "col-sm-12 col-md-7",
      estaGuardando: false,
      estaCargandoDatos: false,
      tieneCargaInicial: false,
    },
    temporizadorGuardado: null,
    eventosActualizacion: [],
    numeroMesaEsperado: null,
    actual: {
      t1NumeroMesa: null,
      t1NroElectoresHabilesMesa: null,
      t1MesaInstaloHoraEstablecida: null,
      t1MesaInstaloHoraInicio: null,
      t1MesaInstaloHoraEstablecidaDetalle: null,
      t1FaltaronMiembrosMesa: null,
      t1FaltaronMiembrosMesaDetalle: null,
      t1MiembroMesaReclutadoFila: null,
      t1MiembroMesaReclutadoFilaDetalle: null,
      t1MaterialElectoralCompleto: null,
      t1MaterialElectoralCompletoDetalle: null,
      t1CabinaGarantizaVotoSecreto: null,
      t1CabinaGarantizaVotoSecretoDetalle: null,
      t1AnforaDebidamenteSellada: null,
      t1AnforaDebidamenteSelladaDetalle: null,
      t1PresenciaPersonerosMesa: null,
      t1PresenciaPersonerosMesaDetalle: null,
      itemsPersonerosMesa: [],
      t1ListaElectoresVisible: null,
      t1ListaElectoresVisibleDetalle: null,
    },
    guardado: {
      t1NumeroMesa: null,
      t1NroElectoresHabilesMesa: null,
      t1MesaInstaloHoraEstablecida: null,
      t1MesaInstaloHoraInicio: null,
      t1MesaInstaloHoraEstablecidaDetalle: null,
      t1FaltaronMiembrosMesa: null,
      t1FaltaronMiembrosMesaDetalle: null,
      t1MiembroMesaReclutadoFila: null,
      t1MiembroMesaReclutadoFilaDetalle: null,
      t1MaterialElectoralCompleto: null,
      t1MaterialElectoralCompletoDetalle: null,
      t1CabinaGarantizaVotoSecreto: null,
      t1CabinaGarantizaVotoSecretoDetalle: null,
      t1AnforaDebidamenteSellada: null,
      t1AnforaDebidamenteSelladaDetalle: null,
      t1PresenciaPersonerosMesa: null,
      t1PresenciaPersonerosMesaDetalle: null,
      itemsPersonerosMesa: [],
      t1ListaElectoresVisible: null,
      t1ListaElectoresVisibleDetalle: null,
    },
    partidos: [],
  }),
  computed: {
    partidosNacionales: function() { return (this.partidos || []).filter(function(p) { return p.regionId == 0; }); },
    partidosRegionales: function() { return (this.partidos || []).filter(function(p) { return p.regionId != 0; }); },
    isDirty: function() {
      return JSON.stringify(this.actual) != JSON.stringify(this.guardado);
    },
    mostrarDetalleFicha: function() {
      if (!this.ui.tieneCargaInicial) return false;
      if (!this.auth.autorizadoEdicionTurno) return false;
      return true;
    },
  },
  methods: {
    inicializarGuardado: function() {
      var vm = this;
      clearTimeout(this.temporizadorGuardado);
      this.temporizadorGuardado = setTimeout(function() {
        if (vm.isDirty) {
          vm.doGuardado();
        }
      }, this.intervaloAutoGuardado);
    },
    doCargarFicha: async function() {
      this.ui.estaCargandoDatos = true;
      var model = {
        mesaVotacionId: this.mesaVotacionId,
        procesoElectoralId: this.procesoElectoralId,
      };

      await this.$http.post(this.apiRoute("Sheet", "GetFichaMesaTurnoUno"), model).then(function(response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          var ficha = response.body.data.ficha;

          var tempActual = this.cloneObject(this.actual);
          var tempGuardado = this.cloneObject(this.guardado);

          tempActual.t1NumeroMesa = this.actualizarBaseDiferente("t1NumeroMesa", tempActual, tempGuardado, ficha);
          tempActual.t1NroElectoresHabilesMesa = this.actualizarBaseDiferente("t1NroElectoresHabilesMesa", tempActual, tempGuardado, ficha);
          tempActual.t1MesaInstaloHoraEstablecida = this.actualizarBaseDiferente("t1MesaInstaloHoraEstablecida", tempActual, tempGuardado, ficha);
          tempActual.t1MesaInstaloHoraInicio = this.actualizarBaseDiferente("t1MesaInstaloHoraInicio", tempActual, tempGuardado, ficha);
          tempActual.t1MesaInstaloHoraEstablecidaDetalle = this.actualizarBaseDiferente("t1MesaInstaloHoraEstablecidaDetalle", tempActual, tempGuardado, ficha);
          tempActual.t1FaltaronMiembrosMesa = this.actualizarBaseDiferente("t1FaltaronMiembrosMesa", tempActual, tempGuardado, ficha);
          tempActual.t1FaltaronMiembrosMesaDetalle = this.actualizarBaseDiferente("t1FaltaronMiembrosMesaDetalle", tempActual, tempGuardado, ficha);
          tempActual.t1MiembroMesaReclutadoFila = this.actualizarBaseDiferente("t1MiembroMesaReclutadoFila", tempActual, tempGuardado, ficha);
          tempActual.t1MiembroMesaReclutadoFilaDetalle = this.actualizarBaseDiferente("t1MiembroMesaReclutadoFilaDetalle", tempActual, tempGuardado, ficha);
          tempActual.t1MaterialElectoralCompleto = this.actualizarBaseDiferente("t1MaterialElectoralCompleto", tempActual, tempGuardado, ficha);
          tempActual.t1MaterialElectoralCompletoDetalle = this.actualizarBaseDiferente("t1MaterialElectoralCompletoDetalle", tempActual, tempGuardado, ficha);
          tempActual.t1CabinaGarantizaVotoSecreto = this.actualizarBaseDiferente("t1CabinaGarantizaVotoSecreto", tempActual, tempGuardado, ficha);
          tempActual.t1CabinaGarantizaVotoSecretoDetalle = this.actualizarBaseDiferente("t1CabinaGarantizaVotoSecretoDetalle", tempActual, tempGuardado, ficha);
          tempActual.t1AnforaDebidamenteSellada = this.actualizarBaseDiferente("t1AnforaDebidamenteSellada", tempActual, tempGuardado, ficha);
          tempActual.t1AnforaDebidamenteSelladaDetalle = this.actualizarBaseDiferente("t1AnforaDebidamenteSelladaDetalle", tempActual, tempGuardado, ficha);
          tempActual.t1PresenciaPersonerosMesa = this.actualizarBaseDiferente("t1PresenciaPersonerosMesa", tempActual, tempGuardado, ficha);
          tempActual.t1PresenciaPersonerosMesaDetalle = this.actualizarBaseDiferente("t1PresenciaPersonerosMesaDetalle", tempActual, tempGuardado, ficha);
          tempActual.itemsPersonerosMesa = (ficha.itemsPersonerosMesa || []).map(function(x) { return { organizacionPoliticaParamId: x.organizacionPoliticaParamId, numero: x.numero }; });
          tempActual.t1ListaElectoresVisible = this.actualizarBaseDiferente("t1ListaElectoresVisible", tempActual, tempGuardado, ficha);
          tempActual.t1ListaElectoresVisibleDetalle = this.actualizarBaseDiferente("t1ListaElectoresVisibleDetalle", tempActual, tempGuardado, ficha);

          this.actual = this.cloneObject(tempActual);
          this.guardado = this.cloneObject(ficha);
          this.auth = response.body.data.auth;
          this.numeroMesaEsperado = response.body.data.numeroMesaEsperado || "";
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.tieneCargaInicial = true;
      this.ui.estaCargandoDatos = false;
    },
    actualizarBaseDiferente: function(propiedad, fichaActual, fichaGuardado, fichaActualizada) {
      var valorActual = JSON.stringify(fichaActual[propiedad]);
      var valorGuardado = JSON.stringify(fichaGuardado[propiedad]);
      var valorActualizado = JSON.stringify(fichaActualizada[propiedad]);

      if (valorActual == valorGuardado && valorGuardado != valorActualizado) {
        return fichaActualizada[propiedad];
      } else {
        return fichaActual[propiedad];
      }
    },
    doGuardado: async function(omitirNotificacion) {
      if (this.ui.estaGuardando) return;

      var numeroMesaIngresado = (this.actual.t1NumeroMesa != null ? String(this.actual.t1NumeroMesa) : "").trim();
      if (!numeroMesaIngresado) {
        if (omitirNotificacion != true) {
          Swal.fire({
            icon: "warning",
            title: "Número de mesa requerido",
            text: "Debe ingresar el número de mesa antes de guardar.",
          });
        }
        return false;
      }
      if (this.numeroMesaEsperado && numeroMesaIngresado !== (this.numeroMesaEsperado || "").trim()) {
        if (omitirNotificacion != true) {
          Swal.fire({
            icon: "error",
            title: "Número de mesa incorrecto",
            text: "El número de mesa ingresado no corresponde a la mesa que se está evaluando. Se espera la mesa N° " + this.numeroMesaEsperado + ".",
          });
        }
        return false;
      }

      if (!this.isFormValid("frm-mesa-turno-1")) {
        if (omitirNotificacion != true) {
          this.$bvToast.toast("Hay campos con valores incorrectos. Revise los datos ingresados.", {
            title: "Turno 1 - Mesa",
            autoHideDelay: 5000,
            variant: "warning",
            appendToast: false,
            solid: true,
          });
          return false;
        }
      }

      var actualClone = this.cloneObject(this.actual);

      var model = this.cloneObject(this.actual);
      model.mesaVotacionId = this.mesaVotacionId;
      model.procesoElectoralId = this.procesoElectoralId;

      var guardadoExistoso = false;
      this.ui.estaGuardando = true;
      await this.$http.post(this.apiRoute("Sheet", "EditFichaMesaTurnoUno"), model).then(function(response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          this.guardado = actualClone;

          if (omitirNotificacion != true) {
            this.$bvToast.toast("Los cambios se han guardado correctamente.", {
              title: "Turno 1 - Mesa",
              autoHideDelay: 5000,
              variant: "success",
              appendToast: false,
              solid: true,
            });
          }
          guardadoExistoso = true;
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.estaGuardando = false;
      return guardadoExistoso;
    },
    doToggleFinalizado: async function() {
      if (this.finalizado) {
        if (!(await this.sweetConfirm("¿Desea desbloquear esta sección?"))) {
          return;
        }
        this.finalizado = !this.finalizado;
      } else {
        if (!(await this.sweetConfirm("¿Desea finalizar esta sección?"))) {
          return;
        }
        this.finalizado = !this.finalizado;
      }
    },
    fetchPartidosPoliticos: function() {
      var self = this;
      if (!this.localVotacionId) return;
      this.$http.get(this.apiRoute("Parameter", "ListParametrosPoliticos"), { params: { Id: this.localVotacionId } }).then(function(response) {
        var parameterResponse = response.body && response.body.data ? response.body.data : [];
        self.partidos = parameterResponse;
      });
    },
    addItemPersonero: function(arr) {
      if (!arr) return;
      arr.push({ organizacionPoliticaParamId: null, numero: null });
    },
    deleteItemPersonero: function(arr, item) {
      if (!arr) return;
      var idx = arr.indexOf(item);
      if (idx >= 0) arr.splice(idx, 1);
    },
    getImagenPartidoPolitico: function(partidoPoliticoParamId) {
      var partido = this.partidos.find(function(x) { return x.parametroId == partidoPoliticoParamId; });
      var imagen = partido ? partido.imagen : null;
      if (!imagen) imagen = "app-partidos/_no-image.png";
      return this.apiResource(imagen);
    },
  },
  watch: {
    actual: {
      deep: true,
      handler() {
        if (this.intervaloAutoGuardado && !this.ui.estaCargandoDatos) {
          this.inicializarGuardado();
        }
      },
    },
  },
  mounted: function() {
    this.initParsley();
    this.fetchPartidosPoliticos();
    this.doCargarFicha();
  },
  destroyed: function() {
    clearTimeout(this.temporizadorGuardado);
  },
};
</script>
